import script from "./AddressBlockTon.vue?vue&type=script&setup=true&lang=js"
export * from "./AddressBlockTon.vue?vue&type=script&setup=true&lang=js"

import "./AddressBlockTon.vue?vue&type=style&index=0&id=1bc0821f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bc0821f"]])

export default __exports__